import { render, staticRenderFns } from "./ShipmentLineItem.vue?vue&type=template&id=e758f3d0&scoped=true&"
import script from "./ShipmentLineItem.vue?vue&type=script&lang=js&"
export * from "./ShipmentLineItem.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentLineItem.vue?vue&type=style&index=0&id=e758f3d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e758f3d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e758f3d0')) {
      api.createRecord('e758f3d0', component.options)
    } else {
      api.reload('e758f3d0', component.options)
    }
    module.hot.accept("./ShipmentLineItem.vue?vue&type=template&id=e758f3d0&scoped=true&", function () {
      api.rerender('e758f3d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ShipmentsPage/ShipmentLineItem.vue"
export default component.exports